module.exports = __webpack_public_path__ + "img/PYB-Phone.3c6aa771.png";